import { API } from 'aws-amplify';

const API_NAME = 'useradminapi';

export async function listUsers() {
  const response = await API.get(API_NAME, '/users');
  return response.users;
}

export async function listGroups() {
  const response = await API.get(API_NAME, '/groups');
  return response.groups;
}

export async function addUserToGroup(username, groupName) {
  return API.post(API_NAME, `/users/${encodeURIComponent(username)}/groups`, {
    body: { groupName }
  });
}

export async function removeUserFromGroup(username, groupName) {
  return API.del(API_NAME, `/users/${encodeURIComponent(username)}/groups/${encodeURIComponent(groupName)}`);
}

export async function updateUserAttributes(username, attributes) {
  return API.put(API_NAME, `/users/${encodeURIComponent(username)}/attributes`, {
    body: { attributes }
  });
}

export async function setUserEnabled(username, enabled) {
  return API.put(API_NAME, `/users/${encodeURIComponent(username)}/enabled`, {
    body: { enabled }
  });
}
